const ContractExternalActionsView = () => import("@views/public/contract-external-actions/contract-external-actions-view.vue");
import TelephoneSign from "@views/public/contract-external-actions/telephone-sign.vue";
import LandingIncome from "@views/public/contract-external-actions/landing-income.vue";

export const contractExternalActionsRoutes = [
    {
        component: ContractExternalActionsView,
        name: "contract_home",
        path: "contract",
        redirect: { name: "telephone_sign" },
        children: [
            {
                component: TelephoneSign,
                name: "esign",
                path: "esign/:type/:id",
                props: true
            },
            {
                component: LandingIncome,
                name: "landing_income",
                path: "income/:id",
                props: true
            }
        ]
    },
];